import { Link, useNavigate } from 'react-router-dom'
import Header from '../../components/Header'
import Page from '../../components/Page'
import { useCreateAppuntamento } from '../../hooks/appuntamenti'
import AppuntamentoForm from '../../components/AppuntamentoForm'

export default function AppuntamentoCreate() {
  const createAppuntamento = useCreateAppuntamento()
  const navigate = useNavigate()

  return (
    <Page>
      <Header margins>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/appuntamenti">Appuntamenti</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Aggiungi
            </li>
          </ol>
        </nav>
      </Header>
      <div className="py-3 overflow-y-auto flex-1">
        <AppuntamentoForm
          save={async (cat) => {
            const savedApp = await createAppuntamento.mutateAsync(cat)
            navigate(`/appuntamenti/${savedApp.id}`)
          }}
        />
      </div>
    </Page>
  )
}
